import Minze, { EventListeners, MinzeAttrs, MinzeElement, Reactive } from 'minze'
export class LvcDatepickerContainer extends MinzeElement {}
